import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import styles from './NotificationMessage.module.css';

const NotificationMessage = ({ assigned, time, notification, toPath }) => {
  const { t } = useTranslation();

  const containerClass = `${styles.notificationMessageContainer} ${styles.square} ${toPath ? styles.withPath : ''}`;

  // Uklanjamo JavaScript skraćivanje - koristićemo CSS

  const content = (
    <div className={containerClass}>
      <div className={styles.headerRow}>
        <h6 className={styles.assignedBy}>
          {t("By")} {assigned}
        </h6>
        <h6 className={styles.timeStamp}>
          <img 
            className={styles.timeIcon}
            src="../../../images/back-in-time.png" 
            alt={t("Time")}
            loading="lazy"
          />
          {time}
        </h6>
      </div>
      <div>
        <h2 className={styles.notificationContent}>
          {notification}
        </h2>
      </div>
    </div>
  );

  if (toPath) {
    return (
      <Link 
        to={toPath} 
        style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
        aria-label={`${t("Open notification")}: ${notification}`}
        tabIndex={0}
      >
        {content}
      </Link>
    );
  }

  return (
    <div 
      role="article" 
      aria-label={`${t("Notification from")} ${assigned}: ${notification}`}
      tabIndex={0}
    >
      {content}
    </div>
  );
};

export default NotificationMessage;
